'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _actionCreators = require('../../../store/actions/action-creators');

var _Reaction = require('../Reaction');

var _Reaction2 = _interopRequireDefault(_Reaction);

var _ReactionDetails = require('../ReactionDetails');

var _ReactionDetails2 = _interopRequireDefault(_ReactionDetails);

var _logValues = require('../../../shared/logging/log-values');

var _hudlBase = require('hudl-base');

var _propTypes = require('../../../shared/prop-types');

var spt = _interopRequireWildcard(_propTypes);

var _adTrackingUtil = require('../../../utils/ad-tracking-util');

var _adTrackingUtil2 = _interopRequireDefault(_adTrackingUtil);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Reactions = function (_Component) {
  _inherits(Reactions, _Component);

  function Reactions(props) {
    _classCallCheck(this, Reactions);

    var _this = _possibleConstructorReturn(this, (Reactions.__proto__ || Object.getPrototypeOf(Reactions)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      showAddReactionPopup: false,
      showDetailsModal: false,
      reactionToAnimateIn: null,
      reactionToAnimateOut: null
    };

    var logData = _this.props.logData;

    _this.whoReactedLogData = _extends({
      app: _logValues.WEB_APP,
      adTrackingId: _adTrackingUtil2.default.getAdTrackingIdAndSetCookie()
    }, logData);

    switch (logData[_logValues.ORIGIN_KEY]) {
      case _logValues.FEED_ORIGIN:
        _this.whoReactedLogData[_logValues.ORIGIN_KEY] = _logValues.WHO_REACTED_FEED_ORIGIN;
        break;
      case _logValues.USER_TIMELINE_ORIGIN:
        _this.whoReactedLogData[_logValues.ORIGIN_KEY] = _logValues.WHO_REACTED_USER_TIMELINE_ORIGIN;
        break;
      case _logValues.TEAM_PROFILE_ORIGIN:
        _this.whoReactedLogData[_logValues.ORIGIN_KEY] = _logValues.WHO_REACTED_TEAM_PROFILE_ORIGIN;
        break;
      default:
        break;
    }
    return _this;
  }

  _createClass(Reactions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _actionCreators.fetchCurrentUserDetailsIfNeeded)());
      dispatch((0, _actionCreators.fetchCommunityContentMetadataIfNeeded)(this.props.communityContentIdObject.type, this.props.communityContentIdObject.relatedId));
    }

    //  We are using the different prop states to determine which reactions need to be animate

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.isLoaded) return;
      var currentPropReactions = this.props.reactions || {};
      var reactionToAnimateIn = null;
      var reactionToAnimateOut = null;
      nextProps.validReactions.forEach(function (reaction) {
        var currentProp = currentPropReactions[reaction] || {};
        var nextProp = nextProps.reactions[reaction] || {};
        if (nextProp.shouldAnimateOut !== currentProp.shouldAnimateOut && nextProp.shouldAnimateOut) {
          reactionToAnimateOut = reaction;
        }
        if (nextProp.shouldAnimateIn !== currentProp.shouldAnimateIn && nextProp.shouldAnimateIn) {
          reactionToAnimateIn = reaction;
        }
      });

      this.setState({
        reactionToAnimateIn: reactionToAnimateIn,
        reactionToAnimateOut: reactionToAnimateOut
      });
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (!nextProps.isLoaded) return;
      var reactionToAnimateOut = nextState.reactionToAnimateOut;
      if (reactionToAnimateOut) {
        var _props = this.props,
            dispatch = _props.dispatch,
            communityContentIdObject = _props.communityContentIdObject;
        var communityContentType = communityContentIdObject.type,
            communityContentRelatedId = communityContentIdObject.relatedId;

        var reactionObj = this.props.reactions[reactionToAnimateOut] || {};
        this.animateRemovalOfReaction(this.refs['reactionListElem-' + reactionToAnimateOut], reactionObj.count);
        dispatch((0, _actionCreators.setReactionShouldAnimateOut)(communityContentType, communityContentRelatedId, reactionToAnimateOut, false));
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!this.props.isLoaded) return;
      var reactionToAnimateIn = this.state.reactionToAnimateIn;
      if (reactionToAnimateIn) {
        var _props2 = this.props,
            dispatch = _props2.dispatch,
            communityContentIdObject = _props2.communityContentIdObject;
        var communityContentType = communityContentIdObject.type,
            communityContentRelatedId = communityContentIdObject.relatedId;

        var reactionObj = this.props.reactions[reactionToAnimateIn] || {};
        this.animateAddingReaction(this.refs['reactionListElem-' + reactionToAnimateIn], reactionObj.count);
        dispatch((0, _actionCreators.setReactionShouldAnimateIn)(communityContentType, communityContentRelatedId, reactionToAnimateIn, false));
      }
    }

    // Replacing the class names that we need for proper styling

  }, {
    key: 'triggerReflow',
    value: function triggerReflow(reaction) {
      if (reaction.className === 'reaction animate' || reaction.className === 'reaction animate-enter') {
        reaction.className = 'reaction reacted';
      }
    }
  }, {
    key: 'animateAddingReaction',
    value: function animateAddingReaction(reactionRef, count) {
      if (count === 1) {
        reactionRef.childNodes[0].className = 'reaction animate-enter';
      } else {
        reactionRef.childNodes[0].className = 'reaction animate';
      }
      setTimeout(this.triggerReflow, 1000, reactionRef.childNodes[0]);
    }
  }, {
    key: 'animateRemovalOfReaction',
    value: function animateRemovalOfReaction(reactionRef, count) {
      if (count > 1) {
        //  If you double-click the svg, we get into a weird state where the animation doesn't complete.
        //  Fix: replacing the HTML with a copy of the svg element.
        reactionRef.childNodes[0].className = 'reaction';
        var svg = (0, _jquery2.default)(reactionRef.childNodes[0]).find('svg');
        var svgReplacer = svg.clone();
        svg.replaceWith(svgReplacer[0]);
      } else {
        var width = reactionRef.offsetWidth;
        reactionRef.className = 'animate-removal';

        //  Performing the sliding of the next reaction to the left
        if (reactionRef.nextSibling) {
          reactionRef.addEventListener('DOMNodeRemoved', function () {
            reactionRef.nextSibling.style.marginLeft = width + 1 + 'px';
            (0, _jquery2.default)(reactionRef.nextSibling).animate({ marginLeft: '1px' }, 250);
          }, false);
        }
      }
    }
  }, {
    key: 'onAddReaction',
    value: function onAddReaction(e, reaction) {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          feedContentId = _props3.feedContentId,
          communityContentIdObject = _props3.communityContentIdObject;
      var communityContentType = communityContentIdObject.type,
          communityContentRelatedId = communityContentIdObject.relatedId,
          secondaryRelatedId = communityContentIdObject.secondaryRelatedId;


      var logDataWithFeedContentId = _extends({}, this.whoReactedLogData, _defineProperty({
        app: _logValues.WEB_APP
      }, _logValues.FEED_CONTENT_ID_KEY, feedContentId));

      var data = {
        logData: logDataWithFeedContentId,
        container: logData.container,
        containerType: logData.containerType,
        containerSection: logData.containerSection,
        player: logData.player,
        adTrackingId: logData.adTrackingId
      };

      if (secondaryRelatedId) {
        data.secondaryRelatedId = secondaryRelatedId;
      }

      dispatch((0, _actionCreators.addReactionIfNeeded)(communityContentType, communityContentRelatedId, reaction, data));
    }
  }, {
    key: 'hasReacted',
    value: function hasReacted(reaction) {
      var currentUserReactions = this.props.currentUserReactions;

      return currentUserReactions.includes(reaction);
    }
  }, {
    key: 'getTotalReactionCount',
    value: function getTotalReactionCount() {
      var _props4 = this.props,
          existingReactions = _props4.existingReactions,
          reactions = _props4.reactions;

      return existingReactions.reduce(function (totalCount, reactionType) {
        var _ref = reactions[reactionType] || {},
            _ref$count = _ref.count,
            count = _ref$count === undefined ? 0 : _ref$count;

        return totalCount + count;
      }, 0);
    }
  }, {
    key: 'getReactionDetailsComponent',
    value: function getReactionDetailsComponent() {
      var showDetailsModal = this.state.showDetailsModal;
      var _props5 = this.props,
          currentUserDetails = _props5.currentUserDetails,
          feedContentId = _props5.feedContentId,
          communityContentIdObject = _props5.communityContentIdObject,
          reactionMessageParts = _props5.reactionMessageParts;

      // If we don't have user details data for the current user,
      // we should skip rendering the reaction details component.
      // User details for the current user are required for the list of
      // users who have reacted

      if (!currentUserDetails) {
        return null;
      }

      return _react2.default.createElement(_ReactionDetails2.default, {
        feedContentId: feedContentId,
        communityContentIdObject: communityContentIdObject,
        logData: this.whoReactedLogData,
        onClickPreview: this.onOpenDetailsModal,
        onCloseModal: this.onCloseDetailsModal,
        reactionMessageParts: reactionMessageParts,
        showModal: showDetailsModal
      });
    }
  }, {
    key: 'getReactionComponentList',
    value: function getReactionComponentList() {
      var _this2 = this;

      var _props6 = this.props,
          existingReactions = _props6.existingReactions,
          reactions = _props6.reactions;

      return existingReactions.sort(function (a, b) {
        var aReaction = reactions[a] || {};
        var bReaction = reactions[b] || {};
        var aCount = aReaction.count || 0;
        var bCount = bReaction.count || 0;

        if (aCount > bCount) return -1;
        if (bCount > aCount) return 1;
        return 0;
      }).map(function (reaction) {
        var _ref2 = reactions[reaction] || {},
            _ref2$count = _ref2.count,
            count = _ref2$count === undefined ? 0 : _ref2$count;

        if (count < 1) {
          return null;
        }

        return _react2.default.createElement(
          'li',
          { key: reaction, ref: 'reactionListElem-' + reaction },
          _react2.default.createElement(_Reaction2.default, {
            hasReacted: _this2.hasReacted(reaction),
            onClickReaction: _this2.onToggleReaction,
            reactionCount: count,
            reactionType: reaction,
            ref: 'reactionWrapper-' + reaction
          })
        );
      }, this);
    }
  }, {
    key: 'getReactionActionsComponent',
    value: function getReactionActionsComponent(totalReactionCount) {
      return _react2.default.createElement(
        'div',
        { className: 'reaction-actions' },
        _react2.default.createElement(
          'ul',
          { className: 'reaction-list' },
          totalReactionCount > 0 ? this.getReactionComponentList() : null
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isLoaded) {
        return null;
      }

      var totalReactionCount = this.getTotalReactionCount();
      if (totalReactionCount === 0) {
        return _react2.default.createElement('div', null);
      }

      return _react2.default.createElement(
        'div',
        { className: 'reaction-container' },
        this.getReactionActionsComponent(totalReactionCount),
        this.props.showReactionDetails ? this.getReactionDetailsComponent() : null
      );
    }
  }]);

  return Reactions;
}(_react.Component);

Reactions.propTypes = {
  communityContentIdObject: spt.CommunityContentId.isRequired,
  currentUserDetails: spt.ReactionUserDetails,
  currentUserReactions: _react.PropTypes.arrayOf(_react.PropTypes.string),
  existingReactions: _react.PropTypes.arrayOf(_react.PropTypes.string),
  feedContentId: _react.PropTypes.string,
  logData: _react.PropTypes.object.isRequired,
  pendingReactions: _react.PropTypes.arrayOf(_react.PropTypes.string),
  reactions: _react.PropTypes.objectOf(_react.PropTypes.shape({
    count: _react.PropTypes.number.isRequired,
    mostRecentUsers: _react.PropTypes.array,
    shouldAnimateIn: _react.PropTypes.boolean,
    shouldAnimateOut: _react.PropTypes.boolean
  })),
  reactionMessageParts: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    message: _react.PropTypes.string.isRequired,
    style: _react.PropTypes.number.isRequired
  })),
  reactionMessagePartsAlternate: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    message: _react.PropTypes.string.isRequired,
    style: _react.PropTypes.number.isRequired
  })),
  showReactionDetails: _react.PropTypes.bool,
  validReactions: _react.PropTypes.arrayOf(_react.PropTypes.string),
  dispatch: _react.PropTypes.func.isRequired,
  isLoaded: _react.PropTypes.bool.isRequired
};
Reactions.defaultProps = {
  logData: {},
  pendingReactions: [],
  showReactionDetails: true,
  // TODO: Move validReactions to the store
  validReactions: ['fire', 'top5', '100', 'lightning', 'heart']
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onOpenDetailsModal = function (e) {
    e.preventDefault();

    _this3.setState({
      showDetailsModal: true
    });

    var _props7 = _this3.props,
        feedContentId = _props7.feedContentId,
        logData = _props7.logData;

    // UsageLogEvent converts keys to PascalCase

    var usageLogData = {
      app: _logValues.WEB_APP,
      op: _logValues.WHO_REACTED_BASE,
      func: 'Click'
    };

    if (logData[_logValues.ORIGIN_KEY]) {
      usageLogData.origin = logData[_logValues.ORIGIN_KEY];
    }

    if (feedContentId) {
      usageLogData.feedContentId = feedContentId;
    }

    new _hudlBase.UsageLogEvent({
      logger: 'Feed',
      data: usageLogData
    }).log();
  };

  this.onToggleReaction = function (e, reaction) {
    var _props8 = _this3.props,
        dispatch = _props8.dispatch,
        feedContentId = _props8.feedContentId,
        communityContentIdObject = _props8.communityContentIdObject,
        logData = _props8.logData;
    var communityContentType = communityContentIdObject.type,
        communityContentRelatedId = communityContentIdObject.relatedId,
        secondaryRelatedId = communityContentIdObject.secondaryRelatedId;


    var logDataWithFeedContentId = _extends({}, logData, _defineProperty({
      app: _logValues.WEB_APP
    }, _logValues.FEED_CONTENT_ID_KEY, feedContentId));

    // dedupe some container data
    delete logDataWithFeedContentId.container;
    delete logDataWithFeedContentId.containerType;
    delete logDataWithFeedContentId.containerSection;
    delete logDataWithFeedContentId.player;
    delete logDataWithFeedContentId.adTrackingId;

    var data = {
      logData: logDataWithFeedContentId,
      container: logData.container,
      containerType: logData.containerType,
      containerSection: logData.containerSection,
      player: logData.player,
      adTrackingId: logData.adTrackingId
    };

    if (secondaryRelatedId) {
      data.secondaryRelatedId = secondaryRelatedId;
    }

    dispatch((0, _actionCreators.toggleReactionIfNeeded)(communityContentType, communityContentRelatedId, reaction, data));
  };

  this.onCloseDetailsModal = function () {
    _this3.setState({
      showDetailsModal: false
    });
  };
};

function mapStateToProps(state, ownProps) {
  var _state$reaction = state.reaction,
      contentReactions = _state$reaction.contentReactions,
      pendingContentReactions = _state$reaction.pendingContentReactions;

  var _ref3 = ownProps.communityContentIdObject || {},
      communityContentType = _ref3.type,
      communityContentRelatedId = _ref3.relatedId;

  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

  var reactionData = contentReactions[communityContentIdKey];
  if (!reactionData) {
    return { isLoaded: false };
  }

  var currentUserReactions = reactionData.currentUserReactions,
      existingReactions = reactionData.existingReactions,
      reactions = reactionData.reactions,
      reactionMessageParts = reactionData.reactionMessageParts,
      reactionMessagePartsAlternate = reactionData.reactionMessagePartsAlternate;
  var currentUser = state.userDetails.currentUser;

  var currentUserDetails = currentUser.details;

  return _extends({}, ownProps, {
    isLoaded: true,
    currentUserDetails: currentUserDetails,
    currentUserReactions: currentUserReactions,
    existingReactions: existingReactions,
    pendingReactions: pendingContentReactions[communityContentIdKey],
    reactions: reactions,
    reactionMessageParts: reactionMessageParts,
    reactionMessagePartsAlternate: reactionMessagePartsAlternate
  });
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Reactions);